var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganisations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 384.795,
    height: 179.845,
    viewBox: "0 0 384.795 179.845",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12971",
    "data-name": "Rectangle 12971",
    width: 384.795,
    height: 179.845,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12970",
    "data-name": "Rectangle 12970",
    width: 384.795,
    height: 182.67,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12967",
    "data-name": "Rectangle 12967",
    width: 372.534,
    height: 182.06,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12969",
    "data-name": "Rectangle 12969",
    width: 41.021,
    height: 38.602,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4480",
    "data-name": "Group 4480",
    transform: "translate(16.785 7.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4488",
    "data-name": "Group 4488",
    transform: "translate(-16.785 -7.845)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4487",
    "data-name": "Group 4487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4486",
    "data-name": "Group 4486",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4482",
    "data-name": "Group 4482",
    transform: "translate(12.261 0.61)",
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4481",
    "data-name": "Group 4481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4480-2",
    "data-name": "Group 4480",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8087",
    "data-name": "Path 8087",
    d: "M433.749,150.86c-11.626,48.186-155.838,31.589-232.178,31.589S63.345,185.929,63.345,136.36,108.329-52.964,229.927,27.7C323.851,90,454.132,66.382,433.749,150.86",
    transform: "translate(-63.345 -3.151)",
    fill: "#c0d2e9"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8088",
    "data-name": "Path 8088",
    d: "M1739.019,745.481s-4.265-4.975-.263-8.136c0,0,2.923-1.77,5.306-1.626,0,0-3.377,5.663-2.285,6.227s3.308-6.582,3.308-6.582,6.652-.645,8.791.384c0,0-5.686,4.653-4.489,4.93s7.34-4.291,7.34-4.291,6.191,1.054,5.861,4.83-2.464,4.943-3.4,4.842-6.422-2.194-6.542-1.426,3.182,3.279,5.494,3.4c0,0-4.365,4.813-7.265,3.424s-3.149-3.591-4.957-4.417-3.352-.824-2.605.019,4.019,1.661,5.053,3.49,1.962,3.063-1.039,2.611-7.879-2.648-8.094-5.162Z",
    transform: "translate(-1400.824 -592.867)",
    fill: "#bce2da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8089",
    "data-name": "Path 8089",
    d: "M1752.187,766.845s-16.815-.648-20.529,4.161a12.163,12.163,0,0,1-3.348,4.7l-.394,1.073s2.914-3.072,3.957-3.258c0,0-1.631-5.958,20.314-6.676",
    transform: "translate(-1393.464 -618.393)",
    fill: "#bce2da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8090",
    "data-name": "Path 8090",
    d: "M1713.87,810.979a10.558,10.558,0,0,0-3.86,7.439l.655.059s1.153-4.931,3.236-6.86-.031-.637-.031-.637",
    transform: "translate(-1379.024 -653.666)",
    fill: "#c8dbf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8091",
    "data-name": "Path 8091",
    d: "M1566.537,682.943s6.784-3.8,3.618-8.955c0,0-2.533-3.166-5.246-3.98,0,0,1.447,7.689,0,7.87s-.995-8.684-.995-8.684-7.146-3.437-9.95-3.166c0,0,4.432,7.508,2.985,7.327s-6.422-7.779-6.422-7.779-7.327-1.357-8.5,2.985.724,6.513,1.809,6.784,8.05.181,7.869,1.086-4.885,2.352-7.508,1.538c0,0,2.895,7.146,6.694,6.784s4.975-2.714,7.327-2.894,4.07.452,2.895,1.085-5.156.207-7.055,1.822-3.437,2.61.091,3.333,9.859.271,11.126-2.442Z",
    transform: "translate(-1243.254 -536.586)",
    fill: "#bce2da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8092",
    "data-name": "Path 8092",
    d: "M1560.862,688.843s19,6.151,21.166,13.026a14.432,14.432,0,0,0,1.809,6.6v1.357s-1.99-4.613-3.075-5.246c0,0,4.251-5.97-19.9-15.739",
    transform: "translate(-1258.745 -555.512)",
    fill: "#e4f3f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8093",
    "data-name": "Path 8093",
    d: "M1675.78,786.734a12.527,12.527,0,0,1,1.26,9.863l-.754-.2s.732-5.964-.8-8.964.3-.7.3-.7",
    transform: "translate(-1350.688 -633.774)",
    fill: "#c8dbf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8094",
    "data-name": "Path 8094",
    d: "M1701.48,632.585s-8.943-5.008-4.769-11.8c0,0,3.338-4.173,6.916-5.247,0,0-1.908,10.135,0,10.374s1.311-11.447,1.311-11.447,9.42-4.531,13.116-4.173c0,0-5.843,9.9-3.935,9.658s8.465-10.254,8.465-10.254,9.658-1.789,11.208,3.935-.954,8.585-2.385,8.943-10.612.238-10.373,1.431,6.439,3.1,9.9,2.027c0,0-3.816,9.419-8.823,8.943s-6.558-3.577-9.658-3.816-5.366.6-3.816,1.431,6.8.273,9.3,2.4,4.531,3.44-.119,4.394-13,.358-14.666-3.219Z",
    transform: "translate(-1367.404 -491.467)",
    fill: "#bce2da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8095",
    "data-name": "Path 8095",
    d: "M1743.941,640.362s-25.039,8.108-27.9,17.17a19.022,19.022,0,0,1-2.385,8.7v1.789s2.623-6.081,4.054-6.916c0,0-5.6-7.87,26.231-20.747",
    transform: "translate(-1381.964 -516.415)",
    fill: "#d4e4f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8096",
    "data-name": "Path 8096",
    d: "M1703.912,769.4a16.515,16.515,0,0,0-1.66,13l.994-.267s-.964-7.862,1.056-11.816-.39-.919-.39-.919",
    transform: "translate(-1372.221 -619.578)",
    fill: "#d4e4f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8097",
    "data-name": "Path 8097",
    d: "M1651.434,848.2a17.517,17.517,0,0,0,17.517-17.517h-35.034a17.517,17.517,0,0,0,17.517,17.517",
    transform: "translate(-1317.66 -669.895)",
    fill: "#d4e4f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8098",
    "data-name": "Path 8098",
    d: "M1668.186,916.781h-35.518a2.161,2.161,0,0,1,2.161-2.161h31.2a2.161,2.161,0,0,1,2.161,2.161",
    transform: "translate(-1316.652 -737.588)",
    fill: "#d4e4f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12968",
    "data-name": "Rectangle 12968",
    width: 36.009,
    height: 0.537,
    transform: "translate(315.682 160.785)",
    fill: "#9fc1f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4485",
    "data-name": "Group 4485",
    transform: "translate(105.568 16.083)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4484",
    "data-name": "Group 4484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4483",
    "data-name": "Group 4483",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8099",
    "data-name": "Path 8099",
    d: "M545.423,99.874c-.469-11.619,9.269-16.781,19.226-16.781s20.794,2.58,21.732,18.03c.6,9.939-4.694,16.055-19.951,16.055-5.145,0-9.144-.811-12.207-2.259L546.6,121.7l3.748-9.367c-3.32-3.087-4.719-7.441-4.921-12.454",
    transform: "translate(-545.407 -83.093)",
    fill: "#d2e3fc"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8100",
    "data-name": "Path 8100",
    d: "M980.863,23.415C981.518,7.2,967.929,0,954.034,0S925.02,3.6,923.709,25.158c-.843,13.869,6.551,22.4,27.84,22.4,7.18,0,12.76-1.133,17.034-3.152l10.642,9.456L974,40.794c4.632-4.307,6.584-10.383,6.867-17.379",
    transform: "translate(-744.867)",
    fill: "#d2e3fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8101",
    "data-name": "Path 8101",
    d: "M305.873,654.179H250.648a3.8,3.8,0,0,1-3.8-3.8v-2.47h59.023Z",
    transform: "translate(-199.07 -522.503)",
    fill: "#77a4e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8102",
    "data-name": "Path 8102",
    d: "M387.27,725.622h-3.562l-1-45.329h5.442Z",
    transform: "translate(-308.632 -548.617)",
    fill: "#192b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8103",
    "data-name": "Path 8103",
    d: "M341.917,894.809H307.272v-3.129l17.657-1.593,16.987,1.593Z",
    transform: "translate(-247.797 -717.803)",
    fill: "#192b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8104",
    "data-name": "Path 8104",
    d: "M289.884,900.071a2.85,2.85,0,1,1,2.85,2.85,2.85,2.85,0,0,1-2.85-2.85",
    transform: "translate(-233.775 -723.557)",
    fill: "#192b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8105",
    "data-name": "Path 8105",
    d: "M468.871,900.071a2.85,2.85,0,1,1,2.85,2.85,2.85,2.85,0,0,1-2.85-2.85",
    transform: "translate(-378.117 -723.557)",
    fill: "#192b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8106",
    "data-name": "Path 8106",
    d: "M348.016,683.267H324.069a2.6,2.6,0,0,1-2.6-2.6v-.373h29.149v.373a2.6,2.6,0,0,1-2.6,2.6",
    transform: "translate(-259.245 -548.617)",
    fill: "#192b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8107",
    "data-name": "Path 8107",
    d: "M251.8,436.079a4.945,4.945,0,0,1-4.945-4.946V391.626c0-7.822,5.114-14.162,11.422-14.162H284.1c6.308,0,11.422,6.341,11.422,14.162v44.452Z",
    transform: "translate(-199.07 -304.403)",
    fill: "#1e347a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8108",
    "data-name": "Path 8108",
    d: "M263.739,436.079a2.712,2.712,0,0,1-2.712-2.712V391.626c0-7.822,5.114-14.162,11.422-14.162h25.829c6.308,0,11.422,6.341,11.422,14.162v44.452Z",
    transform: "translate(-210.503 -304.403)",
    fill: "#192b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8109",
    "data-name": "Path 8109",
    d: "M307.983,654.179H244.8a3.134,3.134,0,1,1,0-6.268h63.185a3.134,3.134,0,0,1,0,6.268",
    transform: "translate(-194.888 -522.503)",
    fill: "#1e347a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8110",
    "data-name": "Path 8110",
    d: "M668.348,853.1c-.188,1.821,2.345,2.292,5.283,2.47s2.043.77,6.063,1.543,5.646-.312,5.944-.853c.265-.48-1.6-1.255-3.587-2.13-.25-.109-.5-.222-.751-.334-2.236-1.012-3.475-3.04-5.206-4.926-1.64-1.787-3.154-7.468-3.154-7.468l-5.461-1.228s1.482,5.115,1.993,7.3a6.743,6.743,0,0,1-.6,3.795,7.155,7.155,0,0,0-.523,1.836",
    transform: "translate(-538.284 -677.551)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8111",
    "data-name": "Path 8111",
    d: "M677.207,901.783c2.938.178,2.043.77,6.063,1.543s5.646-.312,5.944-.853c.265-.48-1.6-1.256-3.587-2.13l-.032.034a11.472,11.472,0,0,1-6.1.008c-2.657-.752-5.216-2.372-7.047-2.906a7.167,7.167,0,0,0-.523,1.836c-.188,1.821,2.346,2.292,5.283,2.47",
    transform: "translate(-541.86 -723.763)",
    fill: "#0f2549"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8112",
    "data-name": "Path 8112",
    d: "M409.764,512.047c-2.939-2.064-22.379-5.742-32.3-6.806L366.5,495.722s-9.333,13.824-9.407,24.4c-.034,4.931,2.237,5.421,2.237,5.422s35.151.261,36.691.42c2.522.26,5.849,6.543,6.68,12.266s15.489,29,15.489,29a18.377,18.377,0,0,0,4.47.9,4.466,4.466,0,0,0,2.224-.6s-8.494-50.823-15.121-55.477",
    transform: "translate(-287.974 -399.771)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8113",
    "data-name": "Path 8113",
    d: "M621.375,853.1c-.188,1.821,2.345,2.292,5.283,2.47s2.043.77,6.064,1.543,5.646-.312,5.944-.853c.265-.48-1.6-1.255-3.587-2.13-.25-.109-.5-.222-.751-.334-2.236-1.012-3.474-3.04-5.206-4.926-1.64-1.787-3.154-7.468-3.154-7.468l-5.462-1.228s1.482,5.115,1.993,7.3a6.745,6.745,0,0,1-.6,3.795,7.153,7.153,0,0,0-.523,1.836",
    transform: "translate(-500.403 -677.551)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8114",
    "data-name": "Path 8114",
    d: "M630.235,901.783c2.938.178,2.043.77,6.063,1.543s5.647-.312,5.944-.853c.265-.48-1.6-1.256-3.587-2.13l-.032.034a11.472,11.472,0,0,1-6.1.008c-2.657-.752-5.217-2.372-7.047-2.906a7.165,7.165,0,0,0-.523,1.836c-.188,1.821,2.345,2.292,5.283,2.47",
    transform: "translate(-503.98 -723.763)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8115",
    "data-name": "Path 8115",
    d: "M362.376,512.047c-2.553-1.793-10.232-3.182-18.708-4.214a5.7,5.7,0,0,1-4.84-4.28l-19.716-7.831s-9.333,13.824-9.407,24.4c-.035,4.931,2.237,5.421,2.237,5.422s35.151.261,36.692.42c2.522.26,5.849,6.543,6.68,12.266s15.489,29,15.489,29a18.378,18.378,0,0,0,4.47.9,4.466,4.466,0,0,0,2.224-.6S369,516.7,362.376,512.047",
    transform: "translate(-249.758 -399.771)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8116",
    "data-name": "Path 8116",
    d: "M386.689,182.224s-5.748,2.939-1.559,9.251c0,0-4.938.571-6.18-.849a4.022,4.022,0,0,0,.406.924s-4.784-.627-6.5-2.44,3.631-25.931,16.373-21c0,0,11.329,1.033,8.114,13.8s1.009,13.479,1.009,13.479a6.1,6.1,0,0,1-1.839.286s-.776-.455-.862-.941a2.991,2.991,0,0,0,.217,1.012s-4.632-.333-6.619-2.436-3.658-8.532-2.56-11.093",
    transform: "translate(-300.436 -135.039)",
    fill: "#8e342e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8117",
    "data-name": "Path 8117",
    d: "M466.871,235.158l-.46.064a3.772,3.772,0,0,1-4.242-3.209l-.334-2.405a3.772,3.772,0,0,1,3.209-4.242l.46-.064a3.772,3.772,0,0,1,4.242,3.209l.334,2.405a3.772,3.772,0,0,1-3.209,4.243",
    transform: "translate(-372.414 -181.663)",
    fill: "#d890a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8118",
    "data-name": "Path 8118",
    d: "M397.644,290.45c-1.715,1.324-2.8,6.1-5.565,6.892-10.365,2.959-15.929-9.35-17.75-15.358a9.022,9.022,0,0,1,3.5-1.273c.753-.128,1.548-.228,2.207-.295,1.132-.962,2.7-4.744,2.794-10.5l.5.107,8.382,1.841s-.245,2.647-.3,5.141c-.044,1.951-.107,2.417.043,2.65.652.107,1.42,1.774,1.42,1.774a.02.02,0,0,0,0,.008,53.291,53.291,0,0,1,4.77,9.011",
    transform: "translate(-301.875 -217.674)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8119",
    "data-name": "Path 8119",
    d: "M429.2,272.322s-.246,2.645-.3,5.141c-4.708-.23-7.108-4.578-8.079-6.981Z",
    transform: "translate(-339.366 -218.128)",
    fill: "#ed985f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8120",
    "data-name": "Path 8120",
    d: "M384.615,355.58s-4.929.181-10.282.2c-.633,0-1.274,0-1.911,0-4.361-.019-8.644-.171-10.467-.641-1.781-.458-8.631-5.1-14.114-10.727l0,0c-.424,1.012-.745,1.786-.753,1.848a28.473,28.473,0,0,1-.758,3.742c-.023.083-.044.169-.063.254-.014.067-.027.136-.042.2s-.025.131-.033.2c-.589,3.609,1.205,9.083,1.728,11.866.166.883.2,1.494,0,1.69-8.929,8.467-25.678,6.544-33.031,5.178a2.716,2.716,0,0,1-1.925-3.9c2.835-5.607,8.155-18,7.3-30.621-.029-.431,3.99-14.216,3.99-14.216s3.124-.545,6.733-.837c.341.31,1.043,9.378,5.557,9.9.735.085,5.447,7.281,5.447,7.281l1.426-7.351-1.688-9.753a51.789,51.789,0,0,1,5.155,1.582,5.692,5.692,0,0,1,2.874,2.554c3.155,5.766,13.393,24.36,14.438,24.793a75.253,75.253,0,0,0,8.569,1.855h0c5.222.955,10.827,1.861,10.827,1.861Z",
    transform: "translate(-252.147 -257.915)",
    fill: "#d2e3fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8121",
    "data-name": "Path 8121",
    d: "M470.711,520.5l-1.641.005,0-.007Z",
    transform: "translate(-378.278 -419.748)",
    fill: "#d2e3fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8122",
    "data-name": "Path 8122",
    d: "M425.9,214.021s-11.146-.219-10.9-7.158-1.032-11.64,6.095-11.794,8.416,2.542,8.9,4.878-1.184,13.952-4.09,14.074",
    transform: "translate(-334.671 -157.307)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8123",
    "data-name": "Path 8123",
    d: "M520.883,436.478c-.633,0-1.274,0-1.912,0-4.359-.018-8.644-.171-10.466-.642-1.781-.459-8.632-5.1-14.114-10.727a0,0,0,0,1,0,0,38.956,38.956,0,0,1,1.655-5.168c.5-.743,2.465,6.461,7.06,9.391s11.787,4.984,15.279,4.153c2.352-.56,2.593,1.555,2.5,3",
    transform: "translate(-398.696 -338.613)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8124",
    "data-name": "Path 8124",
    d: "M460.036,272s.071.831,1.9.962c0,0,1.534.11,1.6-.783a4.5,4.5,0,0,0-3.5-.179",
    transform: "translate(-370.992 -219.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8125",
    "data-name": "Path 8125",
    d: "M430.233,253.29a12.244,12.244,0,0,1-7.9-8.056l.675-.167-.338.084.338-.084a11.531,11.531,0,0,0,7.436,7.56l.12.037-.2.666-.127-.039",
    transform: "translate(-340.586 -197.632)",
    fill: "#122544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8126",
    "data-name": "Path 8126",
    d: "M462.684,284.472l-.6-.189a.58.58,0,0,1,.349-1.106l.6.189a.58.58,0,1,1-.349,1.106",
    transform: "translate(-372.319 -228.344)",
    fill: "#d890a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8127",
    "data-name": "Path 8127",
    d: "M421.144,185.584s-2.854,8.453-7.134,9.887-5.7-.264-5.7-.264a12.381,12.381,0,0,0,3.516-7.585s6.916-5.494,9.318-2.038",
    transform: "translate(-329.278 -148.742)",
    fill: "#8e342e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8128",
    "data-name": "Path 8128",
    d: "M447.084,191.28s5.811-.326,7.548,1.329c1.253,1.193,1.223,1.816,1.32,3.407,0,0,2.541-3.92-.074-6.664-2.773-2.909-8.795,1.928-8.795,1.928",
    transform: "translate(-360.547 -151.95)",
    fill: "#8e342e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8129",
    "data-name": "Path 8129",
    d: "M445.109,186.627s-1.455,8.087-6.775,11.025c0,0,5.153-5.274,5.244-10.55s1.531-.475,1.531-.475",
    transform: "translate(-353.491 -148.891)",
    fill: "#8e342e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8130",
    "data-name": "Path 8130",
    d: "M372.858,189.107c1.714,1.813,6.5,2.442,6.5,2.442a3.982,3.982,0,0,1-.4-.925c2.459,1.993,8.5.546,8.5.546-4.816-1.064-3.257-8.015-1.619-8.311a150.561,150.561,0,0,1,3.735-14.7c-.213-.035-.334-.046-.334-.046-12.741-4.935-18.085,19.184-16.372,21",
    transform: "translate(-300.437 -135.037)",
    fill: "#8e342e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8131",
    "data-name": "Path 8131",
    d: "M407.077,231.475l-.46.064a3.773,3.773,0,0,1-4.243-3.209l-.334-2.405a3.773,3.773,0,0,1,3.209-4.242l.46-.064a3.772,3.772,0,0,1,4.242,3.209l.334,2.405a3.773,3.773,0,0,1-3.209,4.242",
    transform: "translate(-324.194 -178.694)",
    fill: "#d890a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8132",
    "data-name": "Path 8132",
    d: "M412.464,178.579c-.273-.513.686-4.5,2.1-7.587a9.36,9.36,0,0,1,3.63-4.008,2.645,2.645,0,0,1,1.514,0,11.551,11.551,0,0,1,1.329.536c-4.036,1.258-7.544,9.717-7.29,10.593a.3.3,0,0,0-.027-.062Z",
    transform: "translate(-332.59 -134.571)",
    fill: "#d890a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8133",
    "data-name": "Path 8133",
    d: "M412.9,239.8l-.229.032a1.88,1.88,0,0,1-2.114-1.6l-.166-1.2a1.88,1.88,0,0,1,1.6-2.114l.229-.032a1.879,1.879,0,0,1,2.114,1.6l.166,1.2a1.88,1.88,0,0,1-1.6,2.114",
    transform: "translate(-330.941 -189.407)",
    fill: "#efd4df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8134",
    "data-name": "Path 8134",
    d: "M563.154,483.281s4.78-.275,5.244-.025a26.144,26.144,0,0,1,3.724,2.54,26.765,26.765,0,0,1,1.456,2.408s-.456.127-.662-.058-1.765-1.842-1.765-1.842l1.6,2.434a1.355,1.355,0,0,1-.773-.266c-.22-.242-1.717-1.764-1.717-1.764l-.51-.1a5.523,5.523,0,0,1,.8.793,4.906,4.906,0,0,1,.469.783,3.731,3.731,0,0,1-.6-.146c-.142-.068-1.484-1.243-1.484-1.243l.711.971a1.869,1.869,0,0,1-.637-.13,9.9,9.9,0,0,0-1.389-1.068,6.259,6.259,0,0,1-2.093-.357c-.573-.3-2.372-1-2.372-1Z",
    transform: "translate(-454.151 -389.634)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8135",
    "data-name": "Path 8135",
    d: "M394.33,312.946s-3.2.932-3.925,1.666c0,0,3.341,8.542,8.159,12.529l1.288-.914V328.3l4.823,3.156s-10.592-15.93-10.345-18.514",
    transform: "translate(-314.839 -252.373)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8136",
    "data-name": "Path 8136",
    d: "M385.942,425.982c-2.529-.98-11.008-4.412-14.415-7.616-3.809-3.586-11.712-16.478-11.712-16.478l13.828-3.378s5.7,8.315,7.318,9.9c1.245,1.217,4.148,1.309,4.148,1.309l-.758,3.742c-.023.083-.044.169-.062.254-.015.067-.027.135-.042.2s-.023.131-.033.2c-.589,3.609,1.205,9.083,1.728,11.866",
    transform: "translate(-290.17 -321.375)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8137",
    "data-name": "Path 8137",
    d: "M462.458,314.356s1.471,11.623.261,17.1c0,0,1.974-3.627,2.251-4.292l-.332-1.994,1.274.443s-1.123-9.267-2.14-10.891-1.391-1.782-1.391-1.782Z",
    transform: "translate(-372.884 -252.373)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8138",
    "data-name": "Path 8138",
    d: "M631.136,484.169s-6.167.228-12.194.2c-1.5-2.319.335-5.1.335-5.1h0c5.221.953,10.827,1.859,10.827,1.859Z",
    transform: "translate(-498.667 -386.503)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8139",
    "data-name": "Path 8139",
    d: "M592.457,512.959h-22.79a1.817,1.817,0,0,1,1.817-1.817h20.974Z",
    transform: "translate(-459.403 -412.206)",
    fill: "#eef3f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8140",
    "data-name": "Path 8140",
    d: "M686.142,392.292l-8.451,24.821H642.227l8.68-24.821Z",
    transform: "translate(-517.919 -316.361)",
    fill: "#c0d2e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8141",
    "data-name": "Path 8141",
    d: "M688.3,392.292l-8.373,24.592-.077.229H644.9l8.68-24.821Z",
    transform: "translate(-520.078 -316.361)",
    fill: "#d8e4f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8142",
    "data-name": "Path 8142",
    d: "M759.149,448.072a2.291,2.291,0,0,1-2.114,1.717,1.322,1.322,0,0,1-1.321-1.717,2.291,2.291,0,0,1,2.114-1.717,1.322,1.322,0,0,1,1.321,1.717",
    transform: "translate(-609.403 -359.96)",
    fill: "#eef3f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8143",
    "data-name": "Path 8143",
    d: "M767.325,392.292l-8.373,24.592H742.9l19.577-24.592Z",
    transform: "translate(-599.103 -316.361)",
    fill: "#d8e4f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8144",
    "data-name": "Path 8144",
    d: "M487.286,470.315s-11.732,1.025-18.216.736V464.68c4.248,1.173,18.211,3.7,18.211,3.7Z",
    transform: "translate(-378.278 -374.737)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8145",
    "data-name": "Path 8145",
    d: "M351.369,321.552s-6.709.153-8.786,2.4,2.06,14.918,2.06,14.918,12.506,15.317,18.762,16.4c0,0,2.734.374,4.01.394,0,0-1.251-3.643,1.076-5.93,0,0-2.679-.75-2.79-1.082s-14.334-27.093-14.334-27.093",
    transform: "translate(-275.803 -259.313)",
    fill: "#d2e3fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8146",
    "data-name": "Path 8146",
    d: "M181.879,611.291h-.061c-.359,0-.648-.531-.64-1.177l.97-75.571,2.858-.6-2.437,76.175c-.021.657-.324,1.171-.69,1.171",
    transform: "translate(-146.11 -430.596)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8147",
    "data-name": "Path 8147",
    d: "M148.978,525.225H432.886a1.945,1.945,0,0,0,1.945-1.945v-.67a1.945,1.945,0,0,0-1.945-1.945H148.978a1.945,1.945,0,0,0-1.945,1.945v.67a1.945,1.945,0,0,0,1.945,1.945",
    transform: "translate(-118.574 -419.886)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8148",
    "data-name": "Path 8148",
    d: "M1580.629,611.291h.061c.359,0,.648-.531.64-1.177l-.97-75.571-2.858-.6,2.437,76.175c.021.657.324,1.171.69,1.171",
    transform: "translate(-1272.164 -430.596)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8149",
    "data-name": "Path 8149",
    d: "M977.708,391.892l8.507,24.848,35.408-.026-8.68-24.821Z",
    transform: "translate(-788.464 -316.038)",
    fill: "#c0d2e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8150",
    "data-name": "Path 8150",
    d: "M982.918,394.71l8.179,24.051.076.225h34.133l-8.479-24.276Z",
    transform: "translate(-792.667 -318.311)",
    fill: "#eef3f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8151",
    "data-name": "Path 8151",
    d: "M1019.541,512.585l49.452-.027a1.817,1.817,0,0,0-1.817-1.817h-48.144Z",
    transform: "translate(-821.791 -411.884)",
    fill: "#efd4df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8152",
    "data-name": "Path 8152",
    d: "M1337.249,260.859h-.464a3.772,3.772,0,0,1-3.761-3.761v-2.428a3.772,3.772,0,0,1,3.761-3.761h.464a3.773,3.773,0,0,1,3.761,3.761V257.1a3.773,3.773,0,0,1-3.761,3.761",
    transform: "translate(-1075.006 -202.343)",
    fill: "#ed7d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8153",
    "data-name": "Path 8153",
    d: "M1172.7,877.393s-.5,7.775-2,7.883c-.2.014-7.63,0-7.63,0l-9.485-.076a3.077,3.077,0,0,1,2.84-2.762c2.774-.477,7.419-2.416,9.106-6.077,1.776-3.851,7.172,1.033,7.172,1.033",
    transform: "translate(-930.295 -705.54)",
    fill: "#0e2c4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8154",
    "data-name": "Path 8154",
    d: "M1242.06,557.45c.362.3,10.023,10.772,9.234,18.812a4.637,4.637,0,0,1-4.638,4.137h-11.767s-12.007,2.146-12.294,4.74-2.743,16.581-7.612,36.458c0,0-3.588,1.235-5.764.353-2.878-1.167-3.3-2.4-3.3-2.4s2.9-44.508,5.194-47.64,25.9-12.444,33.538-13.372-2.594-1.084-2.594-1.084",
    transform: "translate(-972.506 -449.551)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8155",
    "data-name": "Path 8155",
    d: "M994.733,497.155s-6.828-1.588-8.574,0a8.606,8.606,0,0,0-2.3,3.89h10.876Z",
    transform: "translate(-793.424 -400.358)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8156",
    "data-name": "Path 8156",
    d: "M1086.812,877.393s-.5,7.775-2,7.883c-.2.014-7.63,0-7.63,0l-9.485-.076a3.077,3.077,0,0,1,2.84-2.762c2.774-.477,7.419-2.416,9.106-6.077,1.775-3.851,7.172,1.033,7.172,1.033",
    transform: "translate(-861.033 -705.54)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8157",
    "data-name": "Path 8157",
    d: "M1183.693,557.45a64.659,64.659,0,0,1,3.762,12.246,8.816,8.816,0,0,1-8.609,10.7h-27.374s-12.007,2.146-12.293,4.74-2.743,16.581-7.613,36.458c0,0-3.6.945-6.412-.257a7.94,7.94,0,0,1-2.674-2.171s2.928-44.131,5.219-47.263,25.9-12.444,33.539-13.372,22.455-1.084,22.455-1.084",
    transform: "translate(-905.214 -449.551)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8158",
    "data-name": "Path 8158",
    d: "M1312.645,307.767l-4.233,4.064-7.213,0c-.009-.58.016-3,.041-5.191,0-.129,0-.258.005-.384.006-.486.012-.956.017-1.384.014-1.208.026-2.083.026-2.083l1.854-1.268,4.12-2.821,2.228-1.523c0,.037.184,2.03.212,2.319a16.893,16.893,0,0,0,2.942,8.268",
    transform: "translate(-1049.339 -239.658)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8159",
    "data-name": "Path 8159",
    d: "M1294.34,334.441c.138-.058,7.942-3.559,8.855-3.258s2.05,3.089,2.05,3.089l-13.742,3.107a6.825,6.825,0,0,1,2.837-2.938",
    transform: "translate(-1041.523 -267.065)",
    fill: "#b7d3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8160",
    "data-name": "Path 8160",
    d: "M1125.313,370.776c-1.487-9.169-7.765-16.032-10.452-18.6-1.8-2.714-12.4-4.953-12.4-4.953l-13.742,3.107a17.513,17.513,0,0,0-12.114,8.065c-2.7,4.468-10.438,14.687-15.519,15s-21.038,3.414-21.038,3.414v3.925l24.328.668a4.152,4.152,0,0,0,.885-.07c2.094-.4,11.067-2.179,15.529-4.5.712,11.492,1.555,29.04,5.568,31.827,4.245,2.948,34.1,3.342,37.26-1.151,1.618-2.3-.366-15.912-2.844-29.039,3.081-1.466,5.161-3.848,4.538-7.692",
    transform: "translate(-838.739 -280.012)",
    fill: "#d2e3fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8161",
    "data-name": "Path 8161",
    d: "M1308.61,317.459l-.368.228a29.529,29.529,0,0,1-6.707,3.541c.014-1.208.027-2.083.027-2.083l1.854-1.268Z",
    transform: "translate(-1049.613 -256.012)",
    fill: "#eaa16e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8162",
    "data-name": "Path 8162",
    d: "M1277.906,249.662s11.1,1.313,11.81-5.611,2.623-11.418-4.433-12.549-8.706,1.369-9.506,3.623-.739,14.017,2.129,14.537",
    transform: "translate(-1028.484 -186.466)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8163",
    "data-name": "Path 8163",
    d: "M1272.783,218.48s2.095,7.512,3.612,6.885,2.9-1.139,3.1,1.205,1.08,5.095,6.023,4.593,7.021-14.042,5.24-16.169c-5.139-6.137-25.116-3.838-17.978,3.486",
    transform: "translate(-1025.197 -170.531)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8164",
    "data-name": "Path 8164",
    d: "M1238.522,657.744h54.9a3.775,3.775,0,0,0,3.775-3.775v-2.455h-58.674Z",
    transform: "translate(-998.796 -525.408)",
    fill: "#77a4e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8165",
    "data-name": "Path 8165",
    d: "M1192.9,657.744h41.533a2.792,2.792,0,0,0,2.792-2.792v-.647a2.792,2.792,0,0,0-2.792-2.792H1192.9a2.792,2.792,0,0,0-2.792,2.792v.647a2.792,2.792,0,0,0,2.792,2.792",
    transform: "translate(-959.756 -525.408)",
    fill: "#1e347a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8166",
    "data-name": "Path 8166",
    d: "M1379.527,728.764h3.541l.994-45.061h-5.41Z",
    transform: "translate(-1111.803 -551.367)",
    fill: "#192b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8167",
    "data-name": "Path 8167",
    d: "M1303.664,896.95H1338.1v-3.111l-17.553-1.583-16.886,1.583Z",
    transform: "translate(-1051.329 -719.553)",
    fill: "#192b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8168",
    "data-name": "Path 8168",
    d: "M1475.27,902.18a2.833,2.833,0,1,0-2.833,2.833,2.833,2.833,0,0,0,2.833-2.833",
    transform: "translate(-1185.151 -725.271)",
    fill: "#192b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8169",
    "data-name": "Path 8169",
    d: "M1297.343,902.18a2.833,2.833,0,1,0-2.833,2.833,2.833,2.833,0,0,0,2.833-2.833",
    transform: "translate(-1041.663 -725.271)",
    fill: "#192b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8170",
    "data-name": "Path 8170",
    d: "M1297.724,686.66h31.97a2.956,2.956,0,0,0,2.956-2.956h-37.883a2.956,2.956,0,0,0,2.956,2.956",
    transform: "translate(-1044.156 -551.368)",
    fill: "#192b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8171",
    "data-name": "Path 8171",
    d: "M1323.272,440.937a2.7,2.7,0,0,0,2.7-2.7V396.748c0-7.775-5.084-14.079-11.355-14.079h-25.676c-6.271,0-11.355,6.3-11.355,14.079v44.189Z",
    transform: "translate(-1030.296 -308.6)",
    fill: "#1e347a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8172",
    "data-name": "Path 8172",
    d: "M1335.145,440.937a4.916,4.916,0,0,0,4.916-4.916V396.748c0-7.775-5.083-14.079-11.354-14.079h-25.676c-6.271,0-11.355,6.3-11.355,14.079v44.189Z",
    transform: "translate(-1041.662 -308.6)",
    fill: "#192b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8173",
    "data-name": "Path 8173",
    d: "M1266.863,293.006a12.244,12.244,0,0,0,7.9-8.056l-.675-.167.338.083-.337-.084a11.531,11.531,0,0,1-7.436,7.56l-.12.037.2.666.127-.039",
    transform: "translate(-1021.385 -229.66)",
    fill: "#122544"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8174",
    "data-name": "Path 8174",
    d: "M1261.387,324.187l.6-.189a.58.58,0,1,0-.349-1.106l-.6.189a.58.58,0,1,0,.349,1.106",
    transform: "translate(-1016.628 -260.373)",
    fill: "#d890a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8175",
    "data-name": "Path 8175",
    d: "M1288.433,273.954l-.46.064a3.772,3.772,0,0,1-4.243-3.209l-.334-2.405a3.773,3.773,0,0,1,3.209-4.242l.46-.064a3.772,3.772,0,0,1,4.242,3.209l.333,2.405a3.772,3.772,0,0,1-3.208,4.242",
    transform: "translate(-1034.956 -212.95)",
    fill: "#d890a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8176",
    "data-name": "Path 8176",
    d: "M1293.819,221.059c-.274-.513.686-4.5,2.1-7.587a9.36,9.36,0,0,1,3.63-4.008,2.645,2.645,0,0,1,1.514,0,8.612,8.612,0,0,1,1.328.647c-4.036,1.258-7.544,9.605-7.29,10.481a.338.338,0,0,0-.027-.062Z",
    transform: "translate(-1043.352 -168.829)",
    fill: "#d890a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8177",
    "data-name": "Path 8177",
    d: "M1294.254,282.276l-.229.032a1.879,1.879,0,0,1-2.114-1.6l-.166-1.2a1.879,1.879,0,0,1,1.6-2.114l.229-.032a1.879,1.879,0,0,1,2.114,1.6l.167,1.2a1.88,1.88,0,0,1-1.6,2.114",
    transform: "translate(-1041.703 -223.665)",
    fill: "#efd4df"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisations);
export default __webpack_public_path__ + "static/media/Organisations.0fc6778980c30c8173e604ee3319bacb.svg";
export { ForwardRef as ReactComponent };